import { ResLoginSuccess } from './type';

// Store 是抽象的数据源，为了跨技术栈
type Store<T> = {
  value: T;
  set: (newValue: Partial<T>) => void;
};

interface Params {
  API: {
    getSessionId: () => Promise<string>;
    loginByCode: (mobile: string, mobileCaptcha: string, sessionId: string) => Promise<ResLoginSuccess>;
  };
  formStore: Store<{
    mobile: string;
    mobileCaptcha: string;
    agreement: boolean;
  }>;
  stateStore: Store<{
    loginLoading: boolean;
    mobileCaptchaeError: string;
  }>;
}

export class CodeLogin {
  private _API;
  public formStore;
  public stateStore;

  constructor(params: Params) {
    this._API = params.API;
    this.formStore = params.formStore;
    this.stateStore = params.stateStore;
  }

  async loginByCode() {
    this.stateStore.set({ loginLoading: true });
    this.stateStore.set({ mobileCaptchaeError: '' });
    try {
      const sessionId = await this._API.getSessionId();
      const { mobile, mobileCaptcha } = this.formStore.value;
      const data = await this._API.loginByCode(mobile, mobileCaptcha, sessionId);
      console.log('loginByCode:r', data);
      return data;
    } catch (err: any) {
      console.log('loginByCode:e', err);
      const errorCode = err?.response?.data?.code;
      if (errorCode === 4002002) {
        this.stateStore.set({ mobileCaptchaeError: '验证码错误' });
      } else if (errorCode === 4002003) {
        this.stateStore.set({ mobileCaptchaeError: '验证码错误次数过多，请稍后重试' });
      } else {
        this.stateStore.set({ mobileCaptchaeError: '登录失败，请稍后重试' });
      }
      return null;
    } finally {
      this.stateStore.set({ loginLoading: false });
    }
  }
}
